import { IPayeeEngagementResponse } from "@wingspanhq/payments/dist/interfaces";
import { servicePayments } from "../servicePayments";
import { extendConfigWithXWingspanUserHeader } from "../../shared/utils/extendHeadersWithXWingspanUser";
import { RequirementStatus } from "@wingspanhq/payments/dist/interfaces/requirement";

export interface WSPayeeEngagementRequirementUpdateRequest {
  status: RequirementStatus | null;
  reason?: string | null;
}

export const updateEngagementRequirementByPayeeId = async (
  payeeId: string,
  engagementId: string,
  requirementId: string,
  request: WSPayeeEngagementRequirementUpdateRequest,
  orgPayerId: string | undefined
): Promise<IPayeeEngagementResponse> => {
  const { data } = await servicePayments.patch(
    `/payee/${payeeId}/engagement/${engagementId}/requirement/${requirementId}`,
    request,
    extendConfigWithXWingspanUserHeader({}, orgPayerId)
  );
  return data;
};
